import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RaisedCardComponent } from './components/raised-card/raised-card.component';
import { SharedModule } from '../../shared/shared.module';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { CountoModule } from 'angular2-counto';

@NgModule({
  declarations: [RaisedCardComponent],
  imports: [
    CommonModule,
    SharedModule,
    ProgressBarModule,
    PlaceholderLoaderModule,
    CountoModule
  ],
  exports: [RaisedCardComponent]
})
export class RaisedCardModule { }
